import React, { useEffect, useState } from "react";
import { Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  invitationCode,
  organizationData,
  organizationUpdate,
  setRewardPoints,
  UserActions,
  weeklyBonus,
} from "../redux/UserActions";
import DropDown from "./Helper/DropDown";

function OrganizationSettings() {
  const dispatch = useDispatch();
  const userSelector = useSelector((state) => state.user);
  const [organization, setOrganization] = useState(userSelector.organization);

  const colors = [
    "gray",
    "red",
    "yellow",
    "green",
    "blue",
    "indigo",
    "purple",
    "pink",
  ];

  const [departments, setDepartments] = useState(organization.departments);
  const [locations, setLocations] = useState(organization.departments);

  const [users, setUsers] = useState(userSelector.users);

  const [newDepartment, setNewDepartment] = useState("");

  const moods = [
    { name: "Well", value: "0" },
    { name: "Happy", value: "3" },
    { name: "Excited", value: "4" },
    { name: "Proud", value: "2" },
    { name: "Creative", value: "1" },
    { name: "Stressed", value: "-1" },
    { name: "Worried", value: "-2" },
    { name: "Sad", value: "-3" },
    { name: "Angry", value: "-5" },
    { name: "Sick", value: "-4" },
  ];

  const columns = ["id", "Name"];

  function departmentAction(action, position) {
    if (action === "Delete") {
      dispatch(
        organizationUpdate({
          departments: departments.filter(
            (current_position) => current_position !== position
          ),
        })
      );
    } else if (action == "Add") {
      dispatch(
        organizationUpdate({
          departments: [
            ...userSelector.organization.departments,
            newDepartment,
          ],
        })
      );
      document.getElementById("new-department").value = "";
    }
  }

  function locationAction(action, position) {
    if (action === "Delete") {
      dispatch(
        organizationUpdate({
          locations: locations.filter(
            (current_position) => current_position !== position
          ),
        })
      );
    } else if (action == "Add") {
      dispatch(
        organizationUpdate({
          locations: [...userSelector.organization.locations, newDepartment],
        })
      );
      document.getElementById("new-location").value = "";
    }
  }

  useEffect(() => {
    dispatch(UserActions.organization({}));
  }, []);

  useEffect(() => {
    setOrganization(userSelector.organization);
    setDepartments(userSelector.organization.departments);
    setLocations(userSelector.organization.locations);
  }, [userSelector.organization]);

  return (
    <div className="flex flex-col gap-y-6 m-2">
      <div className="grid lg:grid-cols-3 sm:grid-cols-1 p-2 gap-3">
        <div className="relative col-span-1 sm:col-start-1 lg:col-start-2">
          <input
            name="name"
            type="text"
            onChange={(e) => {
              setOrganization({
                ...organization,
                [e.target.name]: e.target.value,
              });
            }}
            className="h-14 w-full border border-1.5 rounded-md border-gray-300 text-gray-900 focus:outline-none focus:border-2 p-3"
            defaultValue={organization.name}
          />
          <label className="absolute left-2 px-1 -top-2.5 bg-white text-blue-600 text-sm transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-900 peer-placeholder-shown:top-2 peer-focus:-top-2.5 peer-focus:text-red-600 peer-focus:text-sm">
            Organization Name
          </label>
          <button
            className="absolute right-0 top-0 px-4 bg-green-200 text-black font-medium h-full rounded-r-md"
            onClick={() => {
              dispatch(organizationUpdate({ name: organization.name }));
            }}
          >
            Update
          </button>
        </div>
      </div>
      <div className="relative">
        <div className="grid lg:grid-cols-6 md:grid-cols-2 sm:grid-cols-1 p-2 gap-3 py-4 border border-1 rounded-lg border-gray-100">
          {departments.map((department) => (
            <div className="flex h-20 shadow flex-initial rounded-lg hover:bg-gray-50">
              <div
                className={
                  "flex-initial content-center w-20 h-full rounded-l-lg bg-" +
                  colors[department.charCodeAt(1) % 7] +
                  "-" +
                  Math.floor((department.charCodeAt(1) % 4) + 1) * 100
                }
              >
                <h4 className="mt-6 text-center font-black text-xl text-black">
                  {department[0]}
                </h4>
              </div>
              <h4
                className={
                  "flex-grow w-full ml-2 my-auto align-middle font-semibold text-lg text-black"
                }
              >
                {department}
                <h4
                  className={
                    "ml-4 my-auto align-middle font-light text-sm text-gray-600"
                  }
                >
                  {users.filter((user) => user.position === department)
                    .length === 1
                    ? users.filter((user) => user.position === department)
                        .length + " Member"
                    : users.filter((user) => user.position === department)
                        .length + " Members"}
                </h4>
              </h4>
              <DropDown
                items={["Delete"]}
                _handleSelected={(e) => departmentAction(e, department)}
              />
            </div>
          ))}
          <div className="flex h-20 shadow flex-initial rounded-lg hover:bg-gray-50">
            <div
              className={
                "flex-initial content-center w-20 h-full rounded-l-lg bg-" +
                colors[newDepartment.charCodeAt(0) % 7] +
                "-" +
                Math.floor((newDepartment.charCodeAt(0) % 4) + 1) * 100
              }
            >
              <h4 className="mt-6 text-center font-black text-xl text-black">
                {newDepartment[0]}
              </h4>
            </div>
            <input
              id="new-location"
              className={
                "flex-grow w-full rounded border-gray-300 ml-2 my-auto align-middle font-semibold text-lg text-black"
              }
              onChange={(e) => setNewDepartment(e.target.value)}
            ></input>
            <button
              className="mx-2 w-24 text-center bg-green-300 rounded text-black hover:bg-green-600 font-medium py-2 my-auto"
              onClick={() => departmentAction("Add")}
            >
              Add
            </button>
          </div>
        </div>

        <label className="absolute left-2 px-3 -top-3.5 bg-white text-blue-600 text-md transition-all">
          Departments
        </label>
      </div>
      <div className="relative">
        <div className="grid lg:grid-cols-6 md:grid-cols-2 sm:grid-cols-1 p-2 gap-3 py-4 border border-1 rounded-lg border-gray-100">
          {locations.map((department) => (
            <div className="flex h-20 shadow flex-initial rounded-lg hover:bg-gray-50">
              <div
                className={
                  "flex-initial content-center w-20 h-full rounded-l-lg bg-" +
                  colors[department.charCodeAt(1) % 7] +
                  "-" +
                  Math.floor((department.charCodeAt(1) % 4) + 1) * 100
                }
              >
                <h4 className="mt-6 text-center font-black text-xl text-black">
                  {department[0]}
                </h4>
              </div>
              <h4
                className={
                  "flex-grow w-full ml-2 my-auto align-middle font-semibold text-lg text-black"
                }
              >
                {department}
                <h4
                  className={
                    "ml-4 my-auto align-middle font-light text-sm text-gray-600"
                  }
                >
                  {users.filter((user) => user.position === department)
                    .length === 1
                    ? users.filter((user) => user.position === department)
                        .length + " Member"
                    : users.filter((user) => user.position === department)
                        .length + " Members"}
                </h4>
              </h4>
              <DropDown
                items={["Delete"]}
                _handleSelected={(e) => locationAction(e, department)}
              />
            </div>
          ))}
          <div className="flex h-20 shadow flex-initial rounded-lg hover:bg-gray-50">
            <div
              className={
                "flex-initial content-center w-20 h-full rounded-l-lg bg-" +
                colors[newDepartment.charCodeAt(0) % 7] +
                "-" +
                Math.floor((newDepartment.charCodeAt(0) % 4) + 1) * 100
              }
            >
              <h4 className="mt-6 text-center font-black text-xl text-black">
                {newDepartment[0]}
              </h4>
            </div>
            <input
              id="new-department"
              className={
                "flex-grow w-full rounded border-gray-300 ml-2 my-auto align-middle font-semibold text-lg text-black"
              }
              onChange={(e) => setNewDepartment(e.target.value)}
            ></input>
            <button
              className="mx-2 w-24 text-center bg-green-300 rounded text-black hover:bg-green-600 font-medium py-2 my-auto"
              onClick={() => locationAction("Add")}
            >
              Add
            </button>
          </div>
        </div>

        <label className="absolute left-2 px-3 -top-3.5 bg-white text-blue-600 text-md transition-all">
          Locations
        </label>
      </div>
    </div>
  );
}

export default OrganizationSettings;

/**
 *
 */
